module.exports = __webpack_public_path__ + "static/img/pro_display_4.b1c11f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productDisplay/pro_display_4.jpg
// module id = jqgg
// module chunks = 1